/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/hypot.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the hypotenuse of two numbers. The input can be any numeric values, the return value is always a double.\nHypotenuses of infinities are null.',
  examples: [
    'ROW a = 3.0, b = 4.0\n| EVAL c = HYPOT(a, b)',
  ],
  params: {
    number1: 'Numeric expression. If `null`, the function returns `null`.',
    number2: 'Numeric expression. If `null`, the function returns `null`.',
  },
};

export default docs;
